import {
    addNavMenuItem,
    DataService,
    ModalService,
    NotificationService,
    registerBulkAction,
    registerDashboardWidget,
    registerFormInputComponent,
    registerPageTab,
} from '@vendure/admin-ui/core';
import { map, take } from 'rxjs/operators';
import { RelationReviewInputComponent } from './components/featured-review-selector/featured-review-selector.component';
import { ProductReviewsListComponent } from './components/product-reviews-list/product-reviews-list.component';
import { ReviewCountLinkComponent } from './components/review-count-link/review-count-link.component';
import { StarRatingComponent } from './components/star-rating/star-rating.component';
import { DELETE_PRODUCT_REVIEWS } from './common/fragments.graphql';

function deleteReviews(context: any) {
    const modalService = context.injector.get(ModalService);
    const notificationService = context.injector.get(NotificationService);
    const dataService = context.injector.get(DataService);

    const ids: string[] = (context.selection || []).map((r: any) => r.id);
    if (!ids.length) return;

    modalService
    .dialog({
        title: `Delete ${ids.length} review${ids.length > 1 ? 's' : ''}?`,
        buttons: [
            { type: 'secondary', label: 'Cancel' },
            { type: 'primary', label: 'Delete', returnValue: true },
        ],
    })
    .subscribe((ok: boolean) => {
        if (!ok) return;

        dataService
        .mutate(DELETE_PRODUCT_REVIEWS, { ids })
        .subscribe(
            (res: any) => {
                const results = res?.deleteProductReviews ?? [];
                const failed = results.filter((r: any) => r.result !== 'DELETED');
                if (failed.length === 0) {
                    notificationService.success('Review(s) deleted');
                } else {
                    notificationService.error(`Some deletions failed (${failed.length})`);
                }
                context.clearSelection();
                context.hostComponent.refresh();
            },
            (err: any) => {
                notificationService.error(err?.message ?? 'Delete failed');
            },
        );
    });
}

export default [
    registerFormInputComponent('review-count-link', ReviewCountLinkComponent),
    registerFormInputComponent('star-rating-form-input', StarRatingComponent),
    registerFormInputComponent('review-selector-form-input', RelationReviewInputComponent),
    addNavMenuItem(
        {
            id: 'reviews',
            label: 'Product reviews',
            routerLink: ['/extensions/product-reviews'],
            icon: 'star',
        },
        'catalog',
    ),
    registerDashboardWidget('reviews', {
        title: 'Latest reviews',
        supportedWidths: [4, 6, 8, 12],
        loadComponent: () => import('./widgets/reviews-widget/reviews-widget.component').then(m => m.default),
    }),
    registerPageTab({
        location: 'product-detail',
        route: 'reviews',
        tab: 'Reviews',
        tabIcon: 'star',
        component: ProductReviewsListComponent,
    }),
    registerBulkAction({
        location: 'review-list',
        label: 'Delete Reviews',
        icon: 'trash',
        requiresPermission: 'DeleteCatalog',
        isVisible: (ctx) => ctx.selection.length > 0,
        onClick: deleteReviews,
    }),
];
